export default __webpack_public_path__ + "locales/sr-Latn-RS/SmartBanner.json?hash=3aa344d6c456075a23023a222e89bf2c";